import generateFloat from '../generateFloat'

const CARDS = [
  '♦2',
  '♥2',
  '♠2',
  '♣2',
  '♦3',
  '♥3',
  '♠3',
  '♣3',
  '♦4',
  '♥4',
  '♠4',
  '♣4',
  '♦5',
  '♥5',
  '♠5',
  '♣5',
  '♦6',
  '♥6',
  '♠6',
  '♣6',
  '♦7',
  '♥7',
  '♠7',
  '♣7',
  '♦8',
  '♥8',
  '♠8',
  '♣8',
  '♦9',
  '♥9',
  '♠9',
  '♣9',
  '♦10',
  '♥10',
  '♠10',
  '♣10',
  '♦J',
  '♥J',
  '♠J',
  '♣J',
  '♦Q',
  '♥Q',
  '♠Q',
  '♣Q',
  '♦K',
  '♥K',
  '♠K',
  '♣K',
  '♦A',
  '♥A',
  '♠A',
  '♣A',
] as const

type Card = (typeof CARDS)[number]

export type CalculateHiloBetResultOptions = {
  serverSeed: string
  clientSeed: string
  nonce: number
}

export default function calculateHiloBetResult(
  options: CalculateHiloBetResultOptions
) {
  const { serverSeed, clientSeed, nonce } = options

  const cards: Card[] = []

  for (let i = 0; i < 52; i++) {
    const float = generateFloat({ serverSeed, clientSeed, nonce, round: i })

    const card = CARDS[Math.floor(float * CARDS.length)]

    cards.push(card)
  }

  return cards
}
